<template>
    <section class="section section--with-bg bg--light-gray">
      <div class="container">
        <div class="section__block">
          <h2 class="text-center mb-5 headline--underlined">Veranstaltungen</h2>
        </div>
        <div class="section__block">
          <div class="row">
            <div class="col-12 col-md-6">
              <template v-for="(event, index) in events" :key="event.id">
                <div class="teaser" v-if="index === 0">
                  <div class="teaser__meta">
                    <span class="teaser__meta--large">{{ getEventDay(event.eventDate) }}</span>
                    <span>{{ getEventMonthYear(event.eventDate) }}</span>
                  </div>
                  <div class="teaser__content">
                    <h3>{{ event.title }}</h3>
                    <p>{{ event.text }}</p>
                    <a v-if="event.link !== ''" :href="event.link" class="link link--internal">zur Website</a>
                  </div>
                </div>
              </template>
            </div>
            <div class="col-12 col-md-6">
              <div class="teaser__wrapper--vertical">
                <template v-for="(event, index) in events" :key="event.id">
                  <div class="teaser teaser--vertical" v-if="index > 0 && index <= 3">
                    <div class="teaser__meta">
                      <span class="teaser__meta--large">{{ getEventDay(event.eventDate) }}</span>
                      <span>{{ getEventMonthYear(event.eventDate) }}</span>
                    </div>
                    <div class="teaser__content">
                    <h3>{{ event.title }}</h3>
                    <a v-if="event.link !== ''" :href="event.link" class="link link--internal">zur Website</a>
                  </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="section__block">
          <div class="d-flex flex-column flex-md-row gap-2 justify-content-center">
            <router-link :to="{ name: 'allEvents' }"
                         class="btn btn-primary"
                         v-if="events.length > 0"
            >Alle Veranstaltungen
            </router-link>
            <router-link v-if="userCheckResult" :to="{ name: 'editEvents' }" class="btn btn-warning"
            >Neue Veranstaltung
            </router-link
            >
          </div>
        </div>
      </div>
    </section>
</template>

<script>
import { onMounted, ref } from "vue";
import axios from 'axios';

export default {
  name: "Events",
  computed: {
    userCheckResult() {
      return localStorage.getItem('userCheckResult');
    }
  },

  setup() {
    const events = ref([]);

    const fetchData = async() => {
      try {
        const response = await axios.get('http://localhost:8082/gemeinde/events');
        events.value = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    const getEventDay = (date) => {
      const dateFormatted = new Date(date);
      const day = dateFormatted.getDate().toString().padStart(2, '0');
      return `${day}.`;
    }

    const getEventMonthYear = (date) => {
      const dateFormatted = new Date(date);
      const month = (dateFormatted.getMonth() + 1).toString().padStart(2, '0'); // getMonth is 0-based
      const year = dateFormatted.getFullYear();
      const formattedDate = `${month}.${year}`;
      return formattedDate;
    }

    onMounted(() => {
      fetchData()
    })

    return { 
      events,
      getEventDay,
      getEventMonthYear
     };
  }
}
</script>

<style scoped>

</style>